module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlCalendar", "Calendar" ) ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div id="next-event"><div v-if="nextEvent"><h5>Next scheduled event:</h5><span>{{ nextEvent.nextOccurrence | formatLongDateTime }}<br> '+
((__t=( i18n.tc( "ControlCalendar", "Setting: " ) ))==null?'':__t)+
'{{ nextEvent.program.action === \'ON\' ? \'Home\' : \'Away\' }}</span></div></div><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div data-region="calendar-entries-container"></div></div></div>';
}
return __p;
};
